import { getEnglishWeekdays } from "PFCore/helpers/date";
import { AccountAvailability } from "PFTypes";
import { AvailabilityMode, AvailabilityRule, DurationMode } from "PFTypes/booking";

export const DEFAULT_DAYS = 1;
export const DEFAULT_MINUTES = 60;

const getDefaultStandardAvailability = (
  defaultAvailabilityThreshold: number,
  allowedDurationModes: DurationMode[]
): AvailabilityRule => {
  const isDays = allowedDurationModes.includes(DurationMode.Days);
  return {
    ranges: [
      {
        start: null,
        end: null,
        duration: {
          mode: isDays ? DurationMode.Days : DurationMode.Hours,
          value: isDays ? DEFAULT_DAYS : DEFAULT_MINUTES
        }
      }
    ],
    availability_threshold: defaultAvailabilityThreshold,
    mode: AvailabilityMode.Within
  };
};

const getDefaultTimeRuleAvailability = (
  availability: AccountAvailability,
  defaultAvailabilityThreshold: number
): AvailabilityRule => {
  const calendar = availability?.default_calendar;

  const range = {
    start: null,
    end: null,
    day_of_week: getEnglishWeekdays().map(
      (day) => calendar?.nominal_days?.find(({ day_name }) => day_name === day)?.working_minutes || 0
    )
  };

  return {
    mode: AvailabilityMode.TimeRule,
    availability_threshold: defaultAvailabilityThreshold,
    ranges: [range]
  };
};

export const getDefaultAvailabilityRule = (
  isTimeRule: boolean,
  availability: AccountAvailability,
  defaultAvailabilityThreshold: number,
  allowedDurationModes: DurationMode[]
): AvailabilityRule => {
  if (isTimeRule) {
    return getDefaultTimeRuleAvailability(availability, defaultAvailabilityThreshold);
  }

  return getDefaultStandardAvailability(defaultAvailabilityThreshold, allowedDurationModes);
};
